import { Theme } from '@mui/material';

export const bottomNavigationActionStyles = (theme: Theme) => ({
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: {
        color: theme.palette.text.secondary,
        '&.Mui-selected': {
          color: theme.palette.text.primary,
        },
      },
    },
  },
});
